import React from 'react';
import { LoadingPage } from '../../Components/LoadingOverlay';
import { PaddedPage } from '../../globalStyles';
import { PageTitle, UnexpectedError } from '../Shared';
import { useGetUtilizationEmbedUrl } from './useGetUtilizationEmbedUrl';

/**
 * Renders the care-type utilization Hex dashboard for the provider's
 * organization inside an embedded iframe (PDE-1319). Gating lives in
 * `useShowUtilizationHexDashboard`.
 */
export const UtilizationHexDashboard = () => {
  const vm = useGetUtilizationEmbedUrl();

  if (vm.status === 'loading') {
    return <LoadingPage />;
  }

  if (vm.status === 'error') {
    return <UnexpectedError message={vm.errorMessage} />;
  }

  return (
    <PaddedPage>
      <PageTitle className="mb3">Utilization</PageTitle>
      <iframe
        title="Utilization Dashboard"
        style={{ border: 'none', width: '100%', height: 'calc(100vh - 200px)' }}
        src={vm.embedUrl}
        allow="clipboard-write"
      />
    </PaddedPage>
  );
};
